/**
 * Casa Mirari — "Add all to cart" on outfit pages.
 * Every piece needs a size/colour (select) unless it has a single variant.
 * Adds all pieces in one /cart/add.js call and opens Dawn's cart drawer
 * (falls back to the cart page when the drawer isn't used).
 */
(function () {
  'use strict';
  if (customElements.get('cm-outfit-cart')) return;

  class CmOutfitCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-add-all]');
      this.msg = this.querySelector('.cm-outfit-cart__msg');
      this.label = this.button.textContent;
      this.button.addEventListener('click', () => this.addAll());
      this.querySelectorAll('select[data-variant]').forEach((sel) => {
        sel.addEventListener('change', () => {
          sel.classList.remove('is-missing');
          var opt = sel.options[sel.selectedIndex];
          var price = sel.closest('[data-piece]').querySelector('[data-price]');
          if (opt && opt.dataset.price && price) price.textContent = opt.dataset.price;
          this.say('');
        });
      });
    }

    say(text, isError) {
      this.msg.textContent = text;
      this.msg.classList.toggle('is-error', !!isError);
    }

    addAll() {
      var inputs = Array.prototype.slice.call(this.querySelectorAll('[data-variant]'));
      var missing = inputs.filter((i) => !i.value);
      if (missing.length) {
        missing.forEach((i) => i.classList.add('is-missing'));
        missing[0].focus();
        this.say(this.dataset.msgChoose, true);
        return;
      }
      var items = inputs.map((i) => ({ id: Number(i.value), quantity: 1 }));
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }

      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.msgAdding;
      this.say('');

      fetch(this.dataset.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
        .then((res) => {
          if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || 'error');
          this.button.textContent = this.dataset.msgAdded;
          if (drawer && res.data.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.data);
          } else {
            window.location.href = this.dataset.cartUrl;
          }
        })
        .catch((err) => {
          this.say((err && err.message && err.message !== 'error') ? err.message : this.dataset.msgError, true);
          this.button.textContent = this.label;
        })
        .finally(() => {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          setTimeout(() => { this.button.textContent = this.label; }, 2500);
        });
    }
  }

  customElements.define('cm-outfit-cart', CmOutfitCart);
})();
